__turbopack_context__.v({
  "featureCard": "qQ1IKW_featureCard",
  "featureDesc": "qQ1IKW_featureDesc",
  "featureIcon": "qQ1IKW_featureIcon",
  "featureTitle": "qQ1IKW_featureTitle",
  "featuresGrid": "qQ1IKW_featuresGrid",
  "section": "qQ1IKW_section",
});
